<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="padding: 20px;">
    <div class="row" [ngClass]="messageClass" >
      <div class="col">
        <ng-template [ngIf]="message"><label>{{message}}</label></ng-template>
        <div [innerHtml]="messageHtml"></div>
      </div>
    </div>


</div>


<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">{{'Close' | translate}}</button>
  <button type="button" class="btn btn-primary" (click)="onGotoChatChannel()">{{'GotoChatChannel' | translate}}</button>
</div>

